import Icon from "./Icon";

export { Icon };
export default Icon;
